import { httpClient } from '../http/httpClient'
import { SupportCategoryEnum } from '@/app/utils/supportCategoryEnum'

export interface DocumentTransaction {
  _id: string
  contract: string
  type: string
  sellerName: string
  sellerCpf: string
  sellerPhone: string
  customerName: string
  customerCpf: string
  customerPhone: string
}

export interface CreateSupportResponse {
  user: { _id: string; name: string }
  sellers: [{ _id: string; name: string; cpf: string; phone: string }]
  customers: [{ _id: string; name: string; cpf: string; phone: string }]
  transactions: [
    {
      _id: string
      contract: string
      status?: string
      sellerName: string
      sellerCpf: string
      sellerPhone: string
      customerName: string
      customerPhone: string
      customerCpf: string
    },
  ]
  documentsTransactions?: DocumentTransaction[]
}

export interface CreateSupportParams {
  search: string
  categories: SupportCategoryEnum[]
  documents?: boolean
}

export async function createSupport(supportData: CreateSupportParams) {
  const { data } = await httpClient.post<CreateSupportResponse>(
    '/support',
    supportData,
  )

  return data
}
